<template>
  <div class="box">
    <span style="color: #000">Year： </span>
    <div class="year-range">
      <el-date-picker
        class="startYear"
        v-model="queryParams.auditYearStartTime"
        format="yyyy"
        value-format="yyyy"
        type="year"
        placeholder="Start day"
        @blur="startOnchange()"
        clearable
        :picker-options="pickerStartAuditYear"
      ></el-date-picker>
      <i class="el-icon-right"></i>
      <el-date-picker
        class="endYear"
        v-model="queryParams.auditYearEndTime"
        format="yyyy"
        value-format="yyyy"
        type="year"
        placeholder="End day"
        @blur="endOnchange()"
        clearable
        :picker-options="pickerEndAuditYear"
      ></el-date-picker>
      <i class="el-icon-date" style="margin-right: 20px"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    years: {
      type: Array,
      default() {
        return [];
      },
    },
    yearStartTime: {
      type: String,
      default: "",
    },
    yearEndTime: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 年份 范围选择 绑定
      queryParams: {
        auditYearStartTime: "",
        auditYearEndTime: "",
      },
      // 年饭 范围选择 下拉
      yearRange: {
        startTime: "",
        endTime: "",
      },
      // 审计年度 year日期选择器  开始年度和结束年度 添加限制
      pickerStartAuditYear: {
        disabledDate: (time) => {
          if (this.yearRange.endTime) {
            return (
              time.getFullYear() > this.yearRange.endTime ||
              time.getFullYear() < this.yearRange.startTime
            );
          }
        },
      },
      pickerEndAuditYear: {
        disabledDate: (time) => {
          return (
            time.getFullYear() > this.yearRange.endTime ||
            time.getFullYear() < this.yearRange.startTime
          );
        },
      },
    };
  },
  computed: {
    startTime() {
      return this.queryParams["auditYearStartTime"];
    },
    endTime() {
      return this.queryParams["auditYearEndTime"];
    },
  },
  methods: {
    startOnchange() {
      this.$emit("changeStart");
    },
    endOnchange() {
      this.$emit("changeEnd");
    },
  },
  mounted() {
    console.log("yearData", this.years);
  },
  watch: {
    yearStartTime: {
      handler() {
        this.queryParams["auditYearStartTime"] = this.yearStartTime;
      },
      deep: true,
    },
    yearEndTime: {
      handler() {
        this.queryParams["auditYearEndTime"] = this.yearEndTime;
      },
      deep: true,
    },
    years: {
      handler() {
        console.log("yearData1", this.years);
        this.yearRange["startTime"] = this.years[0].val;
        this.yearRange["endTime"] = this.years[this.years.length - 1].val;
      },
      deep: true,
    },
    startTime(val, oldVal) {
      if (this.queryParams["auditYearEndTime"] !== "") {
        if (val > this.queryParams["auditYearEndTime"]) {
          this.$message({
            message: "The start date must not be later than the end date",
            type: "warning",
          });
          this.queryParams["auditYearStartTime"] = oldVal;
        } else if (val === this.queryParams["auditYearEndTime"]) {
          // console.log(
          //   "触发至少选择连续两年",
          //   this.yearStartTime,
          //   this.yearEndTime
          // );
          if (this.yearStartTime !== "" && this.yearEndTime !== "") {
            this.$message({
              message: "Select at least two consecutive years",
              type: "warning",
            });
            this.queryParams["auditYearStartTime"] = oldVal;
          }
        } else {
          // 传给父组件 yearStartTime
          let data = {};
          data.startTime = val;
          data.endTime = this.queryParams["auditYearEndTime"];
          // console.log("子组件传给父组件");
          this.$emit("func", data);
        }
      } else {
        // 传给父组件 yearStartTime
        let data = {};
        data.startTime = val;
        data.endTime = this.queryParams["auditYearEndTime"];
        // console.log("子组件传给父组件");
        this.$emit("func", data);
      }
    },
    endTime(val, oldVal) {
      if (val < this.queryParams["auditYearStartTime"]) {
        this.$message({
          message: "The end date cannot be earlier than the start date",
          type: "warning",
        });
        this.queryParams["auditYearEndTime"] = oldVal;
      } else if (val === this.queryParams["auditYearStartTime"]) {
        // console.log(
        //   "触发至少选择连续两年22222",
        //   this.yearStartTime,
        //   this.yearEndTime
        // );
        if (this.yearStartTime !== "" && this.yearEndTime !== "") {
          this.$message({
            message: "Select at least two consecutive years",
            type: "warning",
          });
          this.queryParams["auditYearEndTime"] = oldVal;
        }
      } else {
        // 传给父组件 yearStartTime
        let data = {};
        data.startTime = this.queryParams["auditYearStartTime"];
        data.endTime = val;
        this.$emit("func", data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  .box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .year-range {
    // margin-left: 10px;
    border: 1px solid #ddd;
  }

  /deep/.el-select {
    flex-grow: 1;
  }

  /deep/.el-select__tags {
    flex-wrap: nowrap !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /deep/.is-focus {
    border: 1px solid #409eff !important;
  }

  /deep/.el-tag__close,
  .el-icon-close {
    display: none;
  }

  /deep/.el-tag {
    font-size: 14px;
    color: #666;
    border: none !important;
    border-radius: 0px !important;
    border-right: 1px solid #ddd !important;
    background-color: transparent !important;
  }

  /deep/.el-input__inner {
    border-radius: 0;
  }
  /deep/.el-date-editor {
    width: 90px;
    border: none !important;
  }
  .el-date-editor {
    /deep/.el-input__inner {
      padding-right: 0 !important;
      border: none !important;
    }
  }
  .endYear,
  .startYear {
    /deep/.el-input__inner {
      text-align: center !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      border: none !important;
    }
    /deep/.el-input__icon {
      display: none;
    }
  }
}
</style>